<template>
  <div class="text-left">
    <!-- <div > -->
    <!-- <span :title="primaryLabel + ' ' + secondaryLabel"> -->
    <span class="text-primary">{{ primaryLabel }}</span>
    <br />
    <span class="text-secondary">{{ getSecondaryLabel }}</span>
    <br />
    <span v-if="tertiaryLabel" class="text-secondary">{{ tertiaryLabel }}</span>
    <!-- </span> -->
    <!-- </div> -->
  </div>
</template>
<script>
export default {
  props: {
    baseView: Object,
    primaryLabel: {
      type: String,
      default: "",
    },
    secondaryLabel: {
      type: null,
      default: "",
    },
    tertiaryLabel: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: "",
    },
    createModeIsEditMode: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: null,
      default: null,
    },
    isXSmall: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    getSecondaryLabel() {
      if (this.secondaryLabel)
        if (this.isXSmall) {
          return this.secondaryLabel.substring(0, 16) + "...";
        } else {
          return this.secondaryLabel;
        }
      else return "";
    },
  },
};
</script>

<style lang="scss">
.text-left {
  text-align: left;
}
</style>